{
  "buyToken": "购买{{token}}",
  "sellToken": "出售{{token}}",
  "viewOrder": "查看订单",
  "requestedAmount": "申请金额",
  "actualPaidAmount": "实际支付金额",
  "transactionQuantity": "交易数量",
  "completedListedQuantity": "已成交/挂单数量",
  "fastTrack": "极速交易",
  "status": "状态：{{status}}",
  "noOrders": "暂无订单",
  "orderDetails": "订单详情",
  "matchedOrders": "匹配交易订单",
  "listing": "挂单中",
  "transactionCompleted": "交易完成",
  "cancelling": "取消中",
  "transactionCancelled": "交易取消",
  "transactions": "交易订单",
  "cancelListing": "取消挂单",
  "orderInformation": "订单信息",
  "systemOrderNumber": "系统订单号",
  "sourceOrder": "来源订单",
  "createdAt": "创建时间",
  "completedAt": "完成时间",
  "price": "单价",
  "listedQuantity": "挂单总数量",
  "minimumTransaction": "单笔最低成交",
  "completedQuantity": "已成交数量",
  "processingQuantity": "交易中数量",
  "remainingQuantity": "剩余数量",
  "refundedQuantity": "已退还数量",
  "receivedAmount": "已获得",
  "expectedTotal": "预计总获得",
  "paymentMethods": "收款方式",
  "seller": "出售方",
  "buyer": "购买方",
  "specialParty": "特殊交易方",
  "paymentAmount": "支付金额",
  "paymentMethod": "付款方式",
  "expectedReceived": "预计获得",
  "revising": "（修改中）",
  "sellerReceivingInformation": "卖家收款信息",
  "buyerPaymentInformation": "买家付款信息",
  "name": "姓名",
  "bankName": "开户银行",
  "bankBranch": "开户支行",
  "bankAccountNumber": "银行卡号",
  "account": "{{method}}账号",
  "receivingCode": "{{method}}收款码",
  "modificationRequest": "申请修改信息",
  "originalQuantity": "修改前数量",
  "originalAmount": "修改前金额",
  "updatedQuantity": "修改后数量",
  "updatedAmount": "修改后金额",
  "sellerPaymentProof": "卖家交易凭证",
  "imageFormatInvalid": "图片格式不符",
  "imageTooLarge": "图片大小超过了 5MB 的限制",
  "cancelOrder": "取消订单",
  "cancelOrderVideoInstruction": "如果您想取消此笔订单，请录制并上传网银流水视频（需清楚录制当前北京时间）。",
  "cancelOrderVideoSteps": "您可以按照以下步骤操作：打开应用商店 > 搜索并开启网银APP > 卡信息 > 交易明细。",
  "back": "返回",
  "confirmCancel": "确认取消",
  "paymentInProgress": "付款中",
  "buyerPaymentInProgress": "买家付款中",
  "paymentTimeRemaining": "付款剩余时间",
  "buyerPaymentInstruction": "请依照卖家收款信息转帐，上传交易凭证后点击「我已付款」。",
  "waitingForBuyerPayment": "等待买家付款中。",
  "uploadPaymentProof": "上传交易凭证",
  "paymentProofUploadHint": "上传 1 至 3 张图片，每张不超过 5MB，支援 JPG、JPEG、PNG。",
  "paid": "我已付款",
  "startAppeal": "发起申诉",
  "awaitingSellerRelease": "待卖家放币",
  "awaitingRelease": "待放币",
  "releaseTimeRemaining": "放币剩余时间",
  "releaseAfterConfirmation": "币将会在确认收款后释放。",
  "buyerPaidReleaseInstruction": "买家已付款，请确认后点击「释放币」。",
  "buyerPaidConfirmation": "买家已付款，请查看是否收到以下付款人的转账，确认后点击「确认收款，放币」。",
  "appealAmountMismatch": "申诉/金额不符",
  "confirmReceiptAndRelease": "确认收款，放币",
  "sellerReleasedToken": "卖家已放币",
  "respondToOrderChange": "回应修改订单",
  "agreeToOrderChange": "是否同意修改此笔订单？",
  "disagree": "我不同意",
  "agree": "我同意",
  "revisingOrder": "修改中",
  "sellerRequestedOrderChange": "卖家实收金额与预期不符，提出修改订单，请点击「回应修改订单」",
  "orderChangeSubmitted": "您已成功提出修改订单，请等待买家回应。",
  "sellerCancelling": "卖家取消中",
  "orderCancellationInProgress": "订单正在取消中，请稍候，我们将在审核确认后通知您。",
  "appealOrder": "订单申诉",
  "appealOrderDescription": "提起申诉后，客服将介入本次交易，直至申诉结束。",
  "confirmAppeal": "确认申诉",
  "confirmCancelOrder": "您确定要取消此订单吗？",
  "unlistOrder": "下架挂单",
  "lotteryFailed": "抽奖失败，请稍后再试。",
  "lotteryTicketLoadFailed": "无法加载抽奖券，请稍后再试。",
  "drawing": "抽奖中…",
  "draw": "点击抽奖",
  "finishDrawing": "完成抽奖",
  "ticketUnavailable": "该抽奖券已被使用或失效。",
  "congratulations": "恭喜获得",
  "tokenRedEnvelope": "{{token}}红包",
  "redEnvelopeImage": "红包图片",
  "redEnvelopeDelivered": "红包金额已发放至您的钱包余额",
  "noPrize": "啊哦～大奖擦肩而过！再抽一次吧！",
  "appealInProgress": "申诉中",
  "appealSupportInstruction": "请点击右上角「联系客服」与客服联系。",
  "paymentProof": "交易凭证",
  "fastTrackDetails": "极速交易详情"
}
